import type { LockReasonMessage } from '~/helpers/learner/lock-reason'
import type { SessionView } from '~/helpers/learner/session-view'
import { steps } from '~/helpers/learner/session-view'

/** L'attestation est-elle téléchargeable (#10) ? C'est l'API qui le dit, et elle seule. */
export function canDownloadCertificate(session: SessionView): boolean {
  return session.certificate?.unlocked === true
}

const quoted = (titles: (string | null | undefined)[]) => titles.map(title => `« ${title ?? ''} »`).join(', ')

/**
 * Ce qu'il manque pour obtenir l'attestation d'un parcours terminé (#10) : une
 * clé i18n et ses valeurs, ou rien. Tant que le parcours n'est pas terminé,
 * l'avancement le dit déjà ; on ne répète pas « terminez tout ».
 *
 * Un module bloquant qui ne peut plus être refait ne se « réussit » plus : lui
 * dire de le réussir le laisserait chercher un bouton qui n'existe pas. On le
 * renvoie vers son formateur.
 */
export function certificateNotice(session: SessionView): LockReasonMessage | null {
  const { certificate } = session
  if (!certificate || certificate.unlocked || certificate.reason === 'INCOMPLETE') return null

  const blocking = steps(session)
    .filter(step => step.module?.id != null && certificate.blockingModuleIds.includes(step.module.id))
  const final = blocking.filter(step => step.allowRetake === false)
  if (final.length > 0) {
    return { key: 'home.certificate.noRetake', values: { titles: quoted(final.map(step => step.module?.title)) } }
  }

  const titles = quoted(blocking.map(step => step.module?.title))
  return certificate.reason === 'SCORE_TOO_LOW'
    ? { key: 'home.certificate.scoreTooLow', values: { titles, score: Math.round((session.certificateMinScore ?? 0) * 100) } }
    : { key: 'home.certificate.notPassed', values: { titles } }
}
